import { call, select } from 'redux-saga/effects'

import { getInvestmentBenefit } from 'quick-quote/product-life-save-pro/benefit-illustration/components/investment-benefit/selectors'
import _ from 'lodash'

//BI
import AuthApi from 'core/service/distributor/auth-api'
import { getCachedSelfAdvisor } from 'identity/saga'
import { getDistributorProfile } from 'core/service/distributor'
import { christianToThaiDate, christianToThaiWithoutFormat } from 'core/service/lib/date'

import {
  getIdentityProfile,
  getIdentityUser,
  getSelectedOffice,
  getUserDistributorGroup,
  isBancAgent,
  isNewAsteriskOfSummaryMainContract as isUseNewAsteriskOfSummaryMainContract,
} from 'identity/selectors'
import {
  getAge,
  getBirthdate,
  getGenderLabel,
  getInsuredFirstName,
  getInsuredLastName,
} from 'quick-quote/insured-information/selectors'
import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'
import {
  getBenefitSummary,
  getHasNonLevelRider,
  getLegalDisclaimerEndDate,
  getPolicyValues,
  getRiderBenefitTables,
  getTaxDeduction,
} from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getVersion, isReviseQQFlow } from 'quick-quote/selectors'
import {
  getSelectedRiders,
  getSumAssured$,
  getTotalPremium,
  getBasicPremium$,
  getTotalRiderPremium,
  getSelectedPlanName,
  getSelectedPlanCode,
  getcoveragePlanStartDate,
  getSelectedModelFactorLabel,
} from 'quick-quote/product-common/coverage-plan/selectors'
import {
  getCalculatedCoveragePeriod,
  getCalculatedPaymentPeriod,
  getHasShowDisclaimerRiderAsterisk,
  getMappingRiderCampaignDiscountBIMessage,
} from 'quick-quote/product-common/benefit-illustration/selectors'
import { getDisplayBenefitSummaryTable } from 'quick-quote/v2/products/customs/12pl/components/benefit-summary-table/selectors'

//

export function* getBIIHealthyUltraProps(biProps) {
  const basicPlan = yield select(getSelectedDisplayProduct)
  const productCategory = basicPlan.category
  const riders = yield select(getSelectedRiders)
  const genderLabel = yield select(getGenderLabel)
  const age = yield select(getAge)
  const firstName = yield select(getInsuredFirstName)
  const lastName = yield select(getInsuredLastName)
  const birthdate = yield select(getBirthdate)
  const sumAssured$ = yield select(getSumAssured$)
  const selectedModelFactorLabel = yield select(getSelectedModelFactorLabel)
  const calculatedCoveragePeriod = yield select(getCalculatedCoveragePeriod)
  const calculatedPaymentPeriod = yield select(getCalculatedPaymentPeriod)
  const hasNonLevelRider = yield select(getHasNonLevelRider)
  const hasShowDisclaimerRiderAsterisk = yield select(getHasShowDisclaimerRiderAsterisk)
  const totalPremium = yield select(getTotalPremium)
  const basicPremium$ = yield select(getBasicPremium$)
  const totalRiderPremium = yield select(getTotalRiderPremium)
  const benefitSummary = yield select(getBenefitSummary)
  const investmentBenefit = yield select(getInvestmentBenefit)
  const taxDeduction = yield select(getTaxDeduction)
  const policyValue = yield select(getPolicyValues)
  const riderBenefitData = yield select(getRiderBenefitTables)
  const version = yield select(getVersion)
  let profile = yield select(getIdentityProfile)
  const user = yield select(getIdentityUser)
  const accessToken = user.access_token
  const agentInfo = yield call(getCachedSelfAdvisor)
  const bancOffice = yield select(getSelectedOffice)
  profile = getDistributorProfile(profile, agentInfo, bancOffice)
  const distributorType = yield select(getUserDistributorGroup)
  const startDate = yield select(getcoveragePlanStartDate)
  const endDate = yield select(getLegalDisclaimerEndDate)
  const benefitSummaryTable = yield select(getDisplayBenefitSummaryTable)
  const selectedPlanName = yield select(getSelectedPlanName)
  const selectedPlanCode = yield select(getSelectedPlanCode)
  const isBanc = yield select(isBancAgent)
  const isNewAsteriskOfSummaryMainContract = yield select(isUseNewAsteriskOfSummaryMainContract)
  const isReviseQQ = yield select(isReviseQQFlow)
  const getDateTime = () => christianToThaiWithoutFormat().format('Do MMMM YYYY เวลา kk:mm')

  const datetime = yield call(getDateTime)
  const validateFullName = _.isEmpty(firstName) && _.isEmpty(lastName) ? null : { firstName, lastName }
  const riderCampaignDiscountBIMessage = yield select(getMappingRiderCampaignDiscountBIMessage)
  const insured = {
    genderLabel,
    age,
    ...validateFullName,
  }
  return {
    // meta data
    productCategory,
    biType: biProps.biType,

    // data
    basicPlan,
    insured,
    riders,
    birthdate,
    calculatedCoveragePeriod,
    calculatedPaymentPeriod,
    sumAssured: sumAssured$.value,
    basicPremium: basicPremium$.value,
    totalPremium,
    selectedModelFactorLabel,
    hasNonLevelRider,
    hasShowDisclaimerRiderAsterisk,
    benefitSummary,
    benefitSummaryTable,
    investmentBenefit,
    policyValue,
    riderBenefitData,
    version: version.appVersion,
    profile,
    accessToken,
    distributorType,
    startDate: christianToThaiDate(startDate),
    endDate: christianToThaiDate(endDate),
    datetime,
    logo: '',
    redLine: '',
    productGraph: '',
    selectedPlanName,
    selectedPlanCode,
    taxDeduction,
    isBancAgent: isBanc,
    totalRiderPremium,
    isNewAsteriskOfSummaryMainContract,
    isReviseQQ,
    riderCampaignDiscountBIMessage,
  }
}
